import { useGeneralScheduleComponentScheduleForEventQuery } from '@graphql/generated';
import { useEffect, useMemo } from 'react';

export const useGeneralEventScheduleGuest = (eventId: string) => {
  const { data, loading, error, refetch } = useGeneralScheduleComponentScheduleForEventQuery({
    variables: {
      eventId,
    },
    batchMode: 'fast',
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (error && !loading) {
      throw new Error('Failed to load schedule');
    }
  }, [error, loading]);

  const schedule = useMemo(() => {
    return loading || !data?.getGuestGeneralEventScheduleForEvent ? null : data.getGuestGeneralEventScheduleForEvent;
  }, [loading, data]);

  return { schedule, refetch };
};
